import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why I don't write more Nightowls type stuff",
  "description": "",
  "published": "2017-04-03T00:00:00.000Z",
  "redirect_from": ["/blog/dont-write-more-nightowls-stuff/swizec/7534"],
  "categories": "Business, Side Projects, Writing",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote">{`Yo dude! I used to love your emails, and now they're full of self-aggrandizing promotional bullshit. What the hell happened? No wonder your open rates are dropping, nobody wants to read this crap.`}</p>
    </blockquote>
    <p>{`This is the email I sometimes get. I paraphrase, but the gist is that way back when they first subscribed, my emails were deep and meaningful. Now they're… less so.`}</p>
    <p>{`You are correct, dear reader. My emails used to be more deep and meaningful. You subscribed to an email list that shot off from my `}<a parentName="p" {...{
        "href": "http://nightowlsbook.com/"
      }}>{`Nightowls book`}</a>{` – `}<em parentName="p">{`Why Programmers Work at Night`}</em>{`.`}</p>
    <p>{`It's invariably someone from that list.`}</p>
    <p>{`They subscribed to my writing about life as a programmer, working in teams, burnout, interesting quirks of psychology, tips on productivity, and inspiration for engineers. Now they get my technical writing because technical is most of the writing that I do.`}</p>
    <p>{`This is upsetting. I understand. I, too, would be upset.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/04/pexels-photo-348323-1024x576.jpeg",
        "alt": null
      }}></img></p>
    <p>{`I loved writing those emails. I loved writing that content. It's a great venue for writing things that are true. When I say true, I don't mean factual. I mean something more. A `}<em parentName="p">{`true`}</em>{` truth.`}</p>
    <p>{`Those are things that weigh on my mind for weeks, sometimes months. Things that percolate and gestate before they're ready. Or sometimes things that happen and upset me.`}</p>
    <p>{`That's when those things get me in trouble.`}</p>
    <p>{`I write those things with gusto, and it shows. People respond. People feel. People come back. It makes them connect, commiserate, cheer, and applaud. Good emotional stuff. The best.`}</p>
    <p>{`But let me tell you something else that is true.`}</p>
    <p>{`I can't write more of those things. I don't have the firepower. I lack the emotional stamina.`}</p>
    <p>{`That stuff is true writing. It works only when it is true. When the author steps up to the page and bleeds, that's when it hits. When people love it. When it makes you `}<em parentName="p">{`feel`}</em>{`.`}</p>
    <p>{`When it is not that, it falls flat. The writing becomes derivative dreck. Just another bullshit thing trying to inspire you. A productivity hack like all others. Armchair psychology with little understanding.`}</p>
    <p>{`By now, I have started, kept going, and stopped three or four different Nightowls blogs. Invariably, I run out of steam, run out of life experience, and I stop. The book lies unfinished because I don't feel man enough to complete it.`}</p>
    <p>{`Maybe I've just lost the piss and vinegar of youth. Who am I to give you advice about life? What do I know…`}</p>
    <p>{`The same things that worked for me 6 years ago still work for me today. Get your workout, eat good calories, spend time alone, drink caffeine, make stuff. What else is there to say?`}</p>
    <p>{`Now, technical writing. That stuff's fun. There's always something new to discover, something new to play with. You get an idea, you work on it, you forget to sleep, sometimes to eat. A few hours later, you have something cool to show to the world. So you write about it. Hit publish and people love it because it's cool and fun.`}</p>
    <p>{`So here is another thing that is true.`}</p>
    <p>{`That Nightowls book, it sold 2449 copies for a total of $6215 in 4 years (since 2013-03-18). It took me over 3 years to gain 900 or so email subscribers.`}</p>
    <p>{`My technical stuff, React & D3 in particular, that sold 2260 copies in 2 years (since 2015-03-16). $53,000 in revenue if you count workshops. 8,000 or so email subscribers.`}</p>
    <p>{`Nightowls content is art. It makes people feel. Technical content solves problems. It helps people become better engineers. Writing helps `}<em parentName="p">{`me`}</em>{` become a better engineer!`}</p>
    <p>{`So I'm sorry, dear reader. I know you're upset, but I'm going to keep publishing the self-aggrandizing technical bullshit. Sometimes, when it feels right, I still publish Nightowls-type stuff.`}</p>
    <p>{`Have you seen the latest few?`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://swizec.com/blog/coding-more-fun-engineering/swizec/7120"
        }}>{`Why coding is more fun than engineering`}</a>{`, October 2016`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://swizec.com/blog/go-fuck-home/swizec/7139"
        }}>{`Go the fuck home`}</a>{`, October 2016`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://swizec.com/blog/did-an-ama-wasnt-crickets/swizec/7153"
        }}>{`I did an AMA and it wasn't crickets`}</a>{`, October 2016`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://swizec.com/blog/only-self-help-business-advice-you-need/swizec/7190"
        }}>{`These 19 Words are the Only Self-Help & Business Advice You Need`}</a>{`, November 2016`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://swizec.com/blog/filter-bubbles-echo-chambers/swizec/7205"
        }}>{`Let's talk about filter bubbles`}</a>{`, November 2016`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://swizec.com/blog/learned-6x-income-4-years/swizec/7340"
        }}>{`What I learned while 6x-ing my income in 4 years`}</a>{`, January 2017`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://swizec.com/blog/nights-weekends/swizec/7394"
        }}>{`Nights and weekends`}</a>{`, January 2017`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://swizec.com/blog/trouble-vacation/swizec/7463"
        }}>{`The trouble with vacation`}</a>{`, March 2017`}</li>
    </ul>
    <p>{`The content `}<em parentName="p">{`you`}</em>{` love happens and will continue to happen. I promise.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      